import { useEffect, useState } from 'react';
import { apiFetch } from '../utils/api';
import {
  processMemberData,
  filterGroupsByOrg,
  filterUsersByGroup as filterUsersByGroupPure
} from '../utils/rescuePush';

/**
 * 队员列表 + 组织级联多选
 */
export default function useRescuePushRecipients({ setTargetForm, setTrackForm }) {
  const [members, setMembers] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [groups, setGroups] = useState([]);
  const [users, setUsers] = useState([]);
  const [orgStructure, setOrgStructure] = useState({});
  const [missions, setMissions] = useState([]);
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { loadUserSettings, SETTING_KEYS } = await import('../utils/userSettings');
        const { migrateLegacyMissions } = await import('../utils/dashboard/missionsModel');
        const { loadCommandMissionState } = await import('../utils/dashboard/missionPersist');
        // 任务列表只认共享看板 API（项 9），个人 settings 仅作 loadCommandMissionState 首次灌入兜底
        const settings = await loadUserSettings();
        const shared = await loadCommandMissionState(settings);
        const migrated = migrateLegacyMissions({
          missions: shared?.[SETTING_KEYS.MISSIONS],
          activeMissionId: shared?.[SETTING_KEYS.ACTIVE_MISSION_ID],
          missionMemberIds: shared?.[SETTING_KEYS.MISSION_MEMBER_IDS],
          missionGroups: shared?.[SETTING_KEYS.MISSION_GROUPS],
          missionMode: shared?.[SETTING_KEYS.MISSION_MODE]
        });
        if (!cancelled) setMissions(Array.isArray(migrated.missions) ? migrated.missions : []);
      } catch (e) {
        console.warn('加载任务列表失败', e);
        if (!cancelled) setMissions([]);
      }
    })();
    return () => { cancelled = true; };
  }, []);


  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const response = await apiFetch('/api/device/list?display_days=7');
        const data = await response.json();

        console.log('队员数据API响应:', data);

        if (data.success) {
          const devices = data.devices || [];
          console.log('获取到队员数据:', devices.length, '个队员');

          const membersWithCoords = devices.filter((d) => d.last_longitude && d.last_latitude);
          console.log('有坐标的队员:', membersWithCoords.length, '个');

          if (membersWithCoords.length > 0) {
            console.log('队员坐标示例:', membersWithCoords[0]);
          }

          setMembers(devices);

          const processed = processMemberData(devices);
          setOrganizations(processed.organizations);
          setGroups(processed.groups);
          setUsers(processed.users);
          setOrgStructure(processed.orgStructure);
        } else {
          console.error('获取队员数据失败:', data.error || data.message);
        }
      } catch (error) {
        console.error('获取队员数据失败:', error);
      }
    };

    fetchMembers();
  }, []);

  const handleMultiSelect = (formType, field, value, checked) => {
    const setForm = formType === 'target' ? setTargetForm : setTrackForm;

    setForm((prev) => {
      const currentValues = prev[field] || [];
      let newValues;

      if (checked) {
        newValues = [...currentValues, value];
      } else {
        newValues = currentValues.filter((item) => item !== value);
      }

      return {
        ...prev,
        [field]: newValues
      };
    });
  };

  const clearSelection = (formType, field) => {
    const setForm = formType === 'target' ? setTargetForm : setTrackForm;
    setForm((prev) => ({
      ...prev,
      [field]: []
    }));
  };

  const selectAll = (formType, field, options) => {
    const setForm = formType === 'target' ? setTargetForm : setTrackForm;
    setForm((prev) => ({
      ...prev,
      [field]: [...options]
    }));
  };

  const filterUsersByGroup = (userList, selectedGroups) =>
    filterUsersByGroupPure(userList, selectedGroups, orgStructure);

  return {
    members,
    organizations,
    groups,
    users,
    missions,
    orgStructure,
    handleMultiSelect,
    clearSelection,
    selectAll,
    filterGroupsByOrg,
    filterUsersByGroup
  };
}
